import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Switch,
  Tab,
  TablePagination,
  TextField,
  Tooltip,
  Typography,
  styled,
} from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import * as React from "react";
import { useSelector } from "react-redux";
import { ShopifyProductFilter } from "../../../../models/app/AppModels";
import {
  useSaveMatchedLinkInventoryMutation,
  useGetDmsWholegoodsMutation,
  useGetDmsWholegoodsV2Mutation,
} from "../../../../redux/reducer/features/Integration/DmsSetupSlice";
import { AppState } from "../../../../redux/reducer/rootReducer";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleIcon from "@mui/icons-material/AddCircleOutline";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import { useGetDmsPartsMutation } from "../../../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import { DmsPartRequestDto } from "../../../../models/features/ShoppingPortal/DmsPart";
import {
  getProductTypeChip,
  getStoreProductStatusChip,
  setupTypeLabelMap,
} from "../../../../services/utilities/utility";
import { useNavigate } from "react-router-dom";
import { LinkInventoryDto } from "../../../../models/features/Integration/shopify";
import {
  ProductType,
  SetupType,
} from "../../../../models/features/Integration/DmsSetup";
import {
  SubscriptionFeatureName,
  useHasSubscriptionFeature,
} from "../../../../services/featurePermissions/subscriptionFeatures";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "2px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
interface LinkInventoryReviewProps {
  StoreProducts: LinkInventoryDto[];
  handleBack: any;
}

const LinkInventoryReview: React.FunctionComponent<LinkInventoryReviewProps> = (
  props,
) => {
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const hasPartsSubscription = useHasSubscriptionFeature(
    SubscriptionFeatureName.Parts,
  );
  const hasWholegoodsSubscription = useHasSubscriptionFeature(
    SubscriptionFeatureName.Wholegoods,
  );
  const setupType = dmsSetup?.setupType;

  const [storeProducts, setStoreProducts] = React.useState<LinkInventoryDto[]>(
    [],
  );
  const navigate = useNavigate();
  const [productType, setProductType] = React.useState(0);
  const [products, setProducts] = React.useState<any[]>([]);
  const [parts, setParts] = React.useState<any[]>([]);
  const [dmsPopup, setDmsPopup] = React.useState(false);
  const [search, setSearch] = React.useState("");

  const [searchStoreProduct, setSearchStoreProduct] = React.useState("");
  const [isFirstLoad, setIsFirstLoad] = React.useState(true);
  const [isUsedProduct, setIsUsedProduct] = React.useState(false);
  const [value, setValue] = React.useState("Wholegoods");
  const [openAggregateProduct, setOpenAggregateProduct] = React.useState(false);
  const [selectedRowData, setSelectedRowData] =
    React.useState<LinkInventoryDto | null>(null);
  const [finishConfirm, setFinishConfirm] = React.useState(false);
  const [redirectConfirm, setRedirectConfirm] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState<string | null>(null);
  const [saveLinkInventoryMutation, saveLinkInventoryMutationResult] =
    useSaveMatchedLinkInventoryMutation();
  const [dmsWhoolgoodsMutation, dmsWhoolgoodsMutationResult] =
    useGetDmsWholegoodsV2Mutation();
  const [getDmsPartsMutation, getDmsPartsMutationResult] =
    useGetDmsPartsMutation();
  const [usedProductsMutation, usedProductsMutationResult] =
    useGetDmsWholegoodsMutation();

  const [storePaging, setStorePaging] = React.useState<ShopifyProductFilter>({
    pageIndex: 0,
    pageSize: 100,
    totalRecords: 0,
    quickFilterValues: [],
    items: [],
  });
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setStorePaging({
      ...storePaging,
      pageIndex: newPage,
    });
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setStorePaging({
      ...storePaging,
      pageSize: parseInt(event.target.value, 10),
      pageIndex: 0,
    });
  };

  // Reset pagination when search changes
  React.useEffect(() => {
    setStorePaging((prev) => ({
      ...prev,
      pageIndex: 0,
    }));
  }, [searchStoreProduct]);
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    if (newValue === "Wholegoods") {
      setProductType(0);
    } else {
      setProductType(1);
    }
  };
  React.useEffect(() => {
    const products = props.StoreProducts ? props.StoreProducts : [];
    setStoreProducts(products);
    setStorePaging((prev) => ({
      ...prev,
      totalRecords: products.length,
      pageIndex: 0, // Reset to first page when data changes
    }));
  }, [props.StoreProducts]);

  const handleClose = () => {
    setDmsPopup(false);
    setOpenAggregateProduct(false);
  };
  const handleSearch = () => {
    fetchWholegoodData();
    if (hasPartsSubscription && !isUsedProduct) {
      fetchPartsData();
    }
  };
  const fetchWholegoodData = () => {
    setIsFirstLoad(false);
    if (isUsedProduct) {
      usedProductsMutation({
        data: {
          dealerIds:
            dmsSetup?.dmsLocations
              .filter((n) => n.storeLocationId > 0)
              .map((n) => n.dealerId.toString()) ?? [],
          search: search,
          searchModels: [],
          stockingOnly: true,
          wildCardSearch: true,
          requestType: "UsedProduct",
        },
      }).then((res: any) => {
        if (res && res?.data) {
          let data = res.data.entityList.map((item: any, index: number) => ({
            ...item,
            id: index,
          }));
          setProducts(data);
        }
      });
    } else {
      dmsWhoolgoodsMutation({
        data: {
          dealerIds:
            dmsSetup?.dmsLocations
              .filter((n) => n.storeLocationId > 0)
              .map((n) => n.dealerId.toString()) ?? [],
          search: search,
          searchModels: [],
          stockingOnly: false,
          wildCardSearch: true,
        },
      }).then((res: any) => {
        if (res && res?.data) {
          let data = res.data.entityList.map((item: any, index: number) => ({
            ...item,
            id: index,
          }));
          setProducts(data);
        }
      });
    }
  };

  const fetchPartsData = () => {
    setIsFirstLoad(false);
    var data: DmsPartRequestDto = {
      dealerIds:
        dmsSetup?.dmsLocations
          .filter((n) => n.storeLocationId > 0)
          .map((n) => n.dealerId.toString()) ?? [],
      pageSize: 1000,
      pageNumber: 0,
      stockingOnly: false,
      searchPartNumber: [],
      searchPartDescription: "",
      search: search,
      searchManufacturerId: "",
      searchManufacturerCode: [],
      searchManufacturerCodeNotIn: [],
      inventoryPartIdNotIn: [],
    };
    getDmsPartsMutation({ data: data }).then((res: any) => {
      if (res && res?.data) {
        let data = res.data.entityList.map((item: any, index: number) => ({
          ...item,
          id: index,
        }));
        setParts(data);
      }
    });
  };
  const handleRemoveMatching = (productId: number) => {
    setStoreProducts((prev) =>
      prev.map((p) =>
        p.externalProductId === productId
          ? { ...p, isMatched: false, dmsWholegood: null, dmsPart: null }
          : p,
      ),
    );
    setOpenAggregateProduct(false);
  };

  const onSyncProductAction = (product: any, productType: string) => {
    setStoreProducts((prev) =>
      prev.map((p) =>
        p.externalProductId === selectedRowData?.externalProductId &&
        p.variantId === selectedRowData?.variantId
          ? {
              ...p,
              isMatched: true,
              productType: productType,
              dmsWholegood:
                productType === "Wholegoods" || productType === "UsedProduct"
                  ? product
                  : null,
              dmsPart: productType === "Parts" ? product : null,
            }
          : p,
      ),
    );
    setDmsPopup(false);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchStoreProduct(value);
  };

  const getPaginatedShopifyProducts = () => {
    const filteredProducts = storeProducts.filter(
      (product) =>
        product.displayName
          ?.toLowerCase()
          .includes(searchStoreProduct?.trim().toLowerCase()) ||
        product.sku
          ?.toLowerCase()
          .includes(searchStoreProduct?.trim().toLowerCase()) ||
        product?.dmsWholegood?.model
          ?.toLowerCase()
          .includes(searchStoreProduct?.trim().toLowerCase()) ||
        product?.dmsPart?.partNumber
          ?.toLowerCase()
          .includes(searchStoreProduct?.trim().toLowerCase()) ||
        product?.vendor
          ?.toLowerCase()
          .includes(searchStoreProduct?.trim().toLowerCase()),
    );

    const sortedProducts = filteredProducts.sort((a, b) => {
      if (a.isMatched && !b.isMatched) return -1;
      if (!a.isMatched && b.isMatched) return 1;
      return 0;
    });

    const startIndex = storePaging.pageIndex * storePaging.pageSize;
    const endIndex = startIndex + storePaging.pageSize;

    return {
      paginatedData: sortedProducts.slice(startIndex, endIndex),
      totalFilteredCount: sortedProducts.length,
    };
  };

  const { paginatedData, totalFilteredCount } = getPaginatedShopifyProducts();
  const dmsDialogTitle =
    hasWholegoodsSubscription && hasPartsSubscription
      ? "DMS Products / Parts"
      : hasPartsSubscription
        ? "DMS Parts"
        : "DMS Products";
  const dmsSearchLabel =
    hasWholegoodsSubscription && hasPartsSubscription
      ? "DMS Product / Part Number"
      : hasPartsSubscription
        ? "DMS Part Number"
        : "DMS Product Number";
  const handleNextStep = () => {
    props.handleBack();
  };
  const handleFinish = () => {
    setErrorMessage(null);
    saveLinkInventoryMutation({
      request: storeProducts.filter((p) => p.isMatched),
    }).then((res: any) => {
      if (res && res?.data && res.data.status === 200) {
        setFinishConfirm(false);
        setRedirectConfirm(true);
      } else {
        setErrorMessage("Saving matched inventory failed. Please try again.");
      }
    });
  };
  function Row({ row, key }: { row: LinkInventoryDto; key: number }) {
    return (
      <React.Fragment>
        <TableRow key={key}>
          <TableCell sx={{ padding: "10px" }}>
            {row.isMatched
              ? row.productType === "Parts"
                ? row.dmsPart?.mfrName
                : row.dmsWholegood?.mfgName
              : row.vendor}
          </TableCell>
          <TableCell sx={{ padding: "10px" }}>
            {row.isMatched
              ? row.productType === "Parts"
                ? row.dmsPart?.partNumber
                : row.dmsWholegood?.model
              : "N/A"}
          </TableCell>
          <TableCell sx={{ padding: "10px" }}>{row.sku}</TableCell>
          <TableCell sx={{ padding: "10px" }}>{row.displayName}</TableCell>
          <TableCell align="center" sx={{ padding: "10px" }}>
            {row.isMatched
              ? row.productType === "Parts"
                ? row.dmsPart?.price?.toFixed(2)
                : row.dmsWholegood?.price?.toFixed(2)
              : (row?.price?.toFixed(2) ?? 0.0)}
          </TableCell>
          <TableCell align="center" sx={{ padding: "10px" }}>
            {row.isMatched ? (
              <Chip size="small" label="Matched" color="success" />
            ) : (
              <Chip size="small" label="Not matched" color="error" />
            )}
          </TableCell>
          <TableCell align="center">
            <Button
              disabled={!row.isMatched}
              color="success"
              variant="contained"
              sx={{ fontSize: "0.6rem", marginRight: "5px" }}
              size="small"
              onClick={() => {
                setSelectedRowData(row);
                setOpenAggregateProduct(true);
              }}
            >
              View
            </Button>
            |
            <Button
              disabled={row.isMatched}
              color="warning"
              variant="contained"
              size="small"
              sx={{ fontSize: "0.6rem", marginLeft: "5px" }}
              onClick={() => {
                setSelectedRowData(row);
                setDmsPopup(true);
              }}
            >
              Sync
            </Button>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
  const columns: GridColDef[] = [
    {
      field: "mfgName",
      headerName: "DMS Manufacturer",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<any>) => params.row.mfgName,
    },
    {
      field: "model",
      headerName: "MPN",
      flex: 1,
      renderHeader: () => (
        <Tooltip title="Manufacturer Product Number">
          <Typography sx={{ fontSize: "0.875rem", fontWeight: 500 }}>
            MPN
          </Typography>
        </Tooltip>
      ),
      valueGetter: (params: GridValueGetterParams<any>) => params.row.model,
    },
    {
      field: "cost",
      headerName: "Cost ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.cost.toFixed(2),
    },
    {
      field: "price",
      headerName: "MSRP ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.price.toFixed(2),
    },
    {
      field: "stock",
      headerName: "Stock",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      valueGetter: (params: GridValueGetterParams<any>) => {
        if (params.row.locationCount) {
          return params.row?.locationCount?.reduce(
            (partial: number, value: any) => partial + value.count,
            0,
          );
        }
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Action",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <IconButton
            id="basic-button"
            onClick={(n) => {
              onSyncProductAction(
                params.row,
                isUsedProduct ? "UsedProduct" : "Wholegoods",
              );
            }}
          >
            <AddCircleIcon />
          </IconButton>
        );
      },
    },
  ];

  const partsColumns: GridColDef[] = [
    {
      field: "mfgName",
      headerName: "DMS Manufacturer",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<any>) => params.row.mfrName,
    },
    {
      field: "partNumber",
      headerName: "Part Number",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.partNumber,
    },
    {
      field: "averageCost",
      headerName: "Cost ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.averageCost.toFixed(2),
    },
    {
      field: "price",
      headerName: "MSRP ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.price.toFixed(2),
    },
    {
      field: "stock",
      headerName: "Stock",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      valueGetter: (params: GridValueGetterParams<any>) => {
        if (params.row.locationCount) {
          return params.row?.locationCount?.reduce(
            (partial: number, value: any) => partial + value.count,
            0,
          );
        }
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Action",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <IconButton
            id="basic-button"
            onClick={(n) => {
              onSyncProductAction(params.row, "Parts");
            }}
          >
            <AddCircleIcon />
          </IconButton>
        );
      },
    },
  ];

  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        gap={2}
        p={0.5}
      >
        <Alert severity="info">
          The only matched{" "}
          {setupType && setupType in setupTypeLabelMap
            ? setupTypeLabelMap[setupType]
            : "Store"}{" "}
          products will be linked with your DMS products and saved to TargetWeb
          once you click Finish. Please review and remove any incorrect matches
          before proceeding.
        </Alert>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Button size="small" variant="outlined" onClick={handleNextStep}>
            Back
          </Button>
          <Button
            size="small"
            variant="contained"
            disabled={storeProducts.some((p) => p.isMatched) ? false : true}
            onClick={() => {
              setFinishConfirm(true);
            }}
          >
            Finish
          </Button>
        </Box>
      </Box>
      <Card sx={{ borderColor: "rgba(0, 0, 0, 0.12)", border: "1px outset" }}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          p={0.5}
        >
          <Alert
            severity={storeProducts.some((p) => p.isMatched) ? "info" : "error"}
          >
            {storeProducts.some((p) => p.isMatched)
              ? `Total matched products = ${
                  storeProducts.filter((p) => p.isMatched).length
                }`
              : `No ${
                  setupType && setupType in setupTypeLabelMap
                    ? setupTypeLabelMap[setupType]
                    : "Store"
                } product got matched with DMS products.`}
          </Alert>
          <TextField
            id="search"
            name="search"
            placeholder="Search.."
            variant="standard"
            size="small"
            onChange={handleChange}
            value={searchStoreProduct}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: "20px" }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <TableContainer component={Paper} sx={{ height: "59vh" }}>
          <Table
            aria-label="collapsible table"
            sx={{ borderCollapse: "separate" }}
          >
            <TableHead
              sx={{
                position: "sticky",
                zIndex: 1,
                top: 0,
                background: "white",
              }}
            >
              <TableRow sx={{ height: "5vh" }}>
                <TableCell sx={{ padding: 0, width: "7%" }}>
                  <span style={{ color: "#E0E0E0" }}>|</span> Manufacturer
                </TableCell>
                <TableCell sx={{ padding: 0, width: "7%" }}>
                  <span style={{ color: "#E0E0E0" }}>|</span> MPN
                </TableCell>
                <TableCell sx={{ padding: 0 }}>
                  <span style={{ color: "#E0E0E0" }}>|</span> SKU
                </TableCell>
                <TableCell sx={{ padding: 0 }}>
                  <span style={{ color: "#E0E0E0" }}>|</span>
                  {dmsSetup?.setupType === SetupType.BigCommerce
                    ? "Product"
                    : "Variant"}{" "}
                  Title
                </TableCell>
                <TableCell align="center" sx={{ padding: 0, width: "7%" }}>
                  <span style={{ color: "#E0E0E0" }}>|</span>Price ($)
                </TableCell>
                <TableCell align="center" sx={{ padding: 0 }}>
                  <span style={{ color: "#E0E0E0" }}>|</span> Matching Status
                </TableCell>
                <TableCell align="center" sx={{ padding: 0, width: "12%" }}>
                  <span style={{ color: "#E0E0E0" }}>|</span> Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData && paginatedData.length > 0 ? (
                paginatedData.map((row) => (
                  <Row key={row.externalProductId} row={row} />
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6}>
                    <Box
                      justifyContent="center"
                      alignItems="center"
                      display="flex"
                      sx={{ height: "60vh" }}
                    >
                      <Typography>
                        {searchStoreProduct
                          ? "No matching products found"
                          : "No Rows to Show"}
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 20, 50, 100]}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            border: "none",
            "& .MuiTablePagination-toolbar": {
              paddingLeft: 0,
            },
          }}
          count={totalFilteredCount}
          rowsPerPage={storePaging.pageSize}
          page={storePaging.pageIndex}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>

      <Dialog open={dmsPopup} onClose={handleClose} maxWidth={"lg"} fullWidth>
        <DialogTitle alignSelf={"center"}>{dmsDialogTitle}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Grid container>
            <Grid item xs={6}>
              <TextField
                id="search"
                name="search"
                label={dmsSearchLabel}
                variant="standard"
                onChange={(event) => {
                  setSearch(event.target.value);
                }}
                value={search}
              />
            </Grid>
            <Grid item style={{ textAlign: "right" }} xs={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={isUsedProduct}
                    name="isUsedProduct"
                    color="warning"
                    onChange={(e) => {
                      setIsUsedProduct(e.target.checked);
                      setProducts([]);
                      setParts([]);
                      setIsFirstLoad(true);
                    }}
                  />
                }
                label="Used Product Only"
              />
              <Button
                variant="contained"
                disabled={
                  search.length < 3 ||
                  getDmsPartsMutationResult.isLoading ||
                  dmsWhoolgoodsMutationResult.isLoading
                }
                onClick={handleSearch}
              >
                Search
              </Button>
            </Grid>
          </Grid>
          <Card sx={{ p: 0 }}>
            <CardContent sx={{ minHeight: 500, p: 0 }}>
              {isFirstLoad ? (
                ""
              ) : (
                <TabContext value={value.toString()}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList onChange={handleTabChange}>
                      {hasWholegoodsSubscription && (
                        <Tab label={"Wholegoods"} value={"Wholegoods"} />
                      )}
                      {hasPartsSubscription && !isUsedProduct && (
                        <Tab label={"Parts"} value={"Parts"} />
                      )}
                    </TabList>
                  </Box>

                  {
                    <TabPanel value="Wholegoods" style={{ padding: 0 }}>
                      <Box sx={{ height: 480, width: "100%" }}>
                        <DataGrid
                          rows={products}
                          columns={columns}
                          loading={
                            dmsWhoolgoodsMutationResult.isLoading ||
                            usedProductsMutationResult.isLoading
                          }
                          components={{}}
                        ></DataGrid>
                      </Box>
                    </TabPanel>
                  }

                  <TabPanel value="Parts" style={{ padding: 0 }}>
                    <Box sx={{ height: 480, width: "100%" }}>
                      <DataGrid
                        rows={parts}
                        columns={partsColumns}
                        loading={getDmsPartsMutationResult.isLoading}
                        components={{}}
                      ></DataGrid>
                    </Box>
                  </TabPanel>
                </TabContext>
              )}
            </CardContent>
          </Card>
        </DialogContent>
      </Dialog>
      <Dialog
        maxWidth="md"
        fullWidth
        open={openAggregateProduct}
        onClose={handleClose}
        PaperProps={{
          style: { height: "50vh" },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "2px",
            paddingBottom: "2px",
          }}
        >
          <Typography color="primary" sx={{ fontWeight: "bold" }}>
            DMS Product Linked to{" "}
            {setupType && setupType in setupTypeLabelMap
              ? setupTypeLabelMap[setupType]
              : "Store"}{" "}
            Variant
          </Typography>
          <IconButton
            onClick={() => {
              handleClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Table aria-label="customized table">
            <TableBody>
              <StyledTableRow
                sx={{
                  height: "40px",
                  backgroundColor: "rgba(0, 0, 0, 0.04) !important",
                }}
              >
                <StyledTableCell sx={{ color: "primary", fontWeight: "bold" }}>
                  Manufacturer
                </StyledTableCell>
                <StyledTableCell sx={{ color: "primary", fontWeight: "bold" }}>
                  Product / Part
                </StyledTableCell>
                <StyledTableCell
                  sx={{ color: "primary", fontWeight: "bold" }}
                  align="right"
                >
                  MSRP ($)
                </StyledTableCell>
                <StyledTableCell
                  sx={{ color: "primary", fontWeight: "bold" }}
                  align="center"
                >
                  Type
                </StyledTableCell>
                <StyledTableCell
                  sx={{ color: "primary", fontWeight: "bold" }}
                  align="center"
                >
                  Action
                </StyledTableCell>
              </StyledTableRow>
              <StyledTableRow key={1}>
                <StyledTableCell>
                  {selectedRowData?.productType === "Parts"
                    ? selectedRowData.dmsPart?.mfrName
                    : selectedRowData?.dmsWholegood?.mfgName}
                </StyledTableCell>
                <StyledTableCell>
                  {selectedRowData?.productType === "Parts"
                    ? selectedRowData?.dmsPart?.partNumber
                    : selectedRowData?.dmsWholegood?.model}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {selectedRowData?.productType === "Parts"
                    ? (selectedRowData?.dmsPart?.price?.toFixed(2) ?? 0)
                    : (selectedRowData?.dmsWholegood?.price?.toFixed(2) ?? 0)}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {getProductTypeChip(
                    selectedRowData?.productType.toString() ?? "",
                  )}
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Button
                    onClick={() => {
                      handleRemoveMatching(
                        selectedRowData?.externalProductId ?? 0,
                      );
                    }}
                    variant="contained"
                    size="small"
                    sx={{ fontSize: "0.6rem" }}
                    color="error"
                  >
                    Delete
                  </Button>
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>
      <Dialog open={finishConfirm} onClose={handleClose}>
        <DialogContent>
          Are you sure you want to finish? This will save all matched products
          in TargetWeb. Your total matched products are{" "}
          <strong>
            {storeProducts.filter((p) => p.isMatched === true).length}
          </strong>
          .
          <br />
          {errorMessage && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {errorMessage}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            onClick={() => setFinishConfirm(false)}
          >
            No
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleFinish}
            disabled={saveLinkInventoryMutationResult.isLoading}
            endIcon={
              saveLinkInventoryMutationResult.isLoading ? (
                <CircularProgress color="inherit" size={16} />
              ) : null
            }
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={redirectConfirm}>
        <DialogContent>
          Link Inventory process is completed. You can now navigate to Manage
          Products Page to view the linked products.
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="contained"
            onClick={() => {
              setRedirectConfirm(false);
              navigate("/ManageProducts");
            }}
          >
            Manage Products
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default LinkInventoryReview;
